import {
  checkoutFlights
} from "./chunk-S4DBG2UM.mjs";

// src/hooks/wbk/flights/checkout.ts
import { useMutation } from "@tanstack/react-query";
var useFlightsCheckout = () => {
  return useMutation({
    mutationFn: checkoutFlights
  });
};

export {
  useFlightsCheckout
};
//# sourceMappingURL=chunk-C66CB5B5.mjs.map